import { Amplify } from 'aws-amplify';
import { getWindow } from './dom';

const AmplifyV6MigrationKey = 'nucleus.amplify.v6.migrated';

function clearStaleAmplifyV5Tokens(storage: Storage) {
  if (storage.getItem(AmplifyV6MigrationKey)) {
    return;
  }

  const keysToRemove = [];
  for (let index = 0; index < storage.length; index++) {
    const storageKey = storage.key(index);
    if (storageKey?.includes('CognitoIdentityServiceProvider')) {
      keysToRemove.push(storageKey);
    }
  }

  keysToRemove.forEach((storageKey) => storage.removeItem(storageKey));
  storage.setItem(AmplifyV6MigrationKey, 'true');
}

export function configureAmplifyAuth(): void {
  const storage = getWindow()?.localStorage;

  if (storage) {
    clearStaleAmplifyV5Tokens(storage);
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env['REACT_APP_AWS_USER_POOL_ID'] ?? '',
        userPoolClientId: process.env['REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID'] ?? '',
      },
    },
  });
}
